module.exports = __webpack_public_path__ + "img/share-copy-active.70904560.png";